export default "__VITE_ASSET__CV1cmE1m__"